import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store/index";
import authActions from "@/store/authentication/actions";
import cmsActions from "@/store/cms/actions";
import { CmsCriteria } from "@/services/cms";
import accountActions from "@/store/accounts/actions";
import Login from "../components/Login.vue";
import FirstTimeTac from "../components/FirstTimeTac.vue";
import Dashboard from "../components/Dashboard.vue";
import TermsConditions from "../components/TermsConditionsPage.vue";
import FeesAndLimits from "../components/FeesAndLimitsPage.vue";
import ReportLostStolen from "../components/ReportLostStolen.vue";
import Pages from "../components/Pages.vue";
import ProfileEdit from "../components/ProfileEdit.vue";
import MyBonuses from "../components/MyBonuses.vue";
import AllTransactions from "../components/AllTransactions.vue";
import ForgottenPass from "@/components/ForgottenPass.vue";
import SetNewPass from "@/components/SetNewPass.vue";
import ConfirmReg from "@/components/ConfirmReg.vue";
import FreezeCard from "@/components/FreezeCard.vue";
import MyVehicle from "@/components/MyVehicle.vue";
import Posts from "../components/Posts.vue";
import routing from "@/constants/routes";
import PrivacyPolicy from "../components/PrivacyPolicy.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: routing.LOGIN,
    name: "LoginPage",
    component: Login,
    meta: { title: "Login", sideBar: false, requiresAuth: false }
  },
  {
    path: routing.TWO_FACTOR_LOGIN,
    name: "BonusMe - First Time TAC",
    component: FirstTimeTac,
    meta: { title: "Login", sideBar: false, requiresAuth: false }
  },
  {
    path: routing.CONDITIONS,
    name: "TermsConditions",
    component: TermsConditions,
    meta: { title: "Terms & Conditions", sideBar: true, requiresAuth: true }
  },
  {
    path: routing.DASHBOARD,
    name: "Dashboard",
    component: Dashboard,
    meta: { title: "Home", sideBar: true, requiresAuth: true }
  },
  {
    path: routing.LIMITS,
    name: "FeesAndLimits",
    component: FeesAndLimits,
    meta: { title: "Fees & Limits", sideBar: true, requiresAuth: true }
  },
  {
    path: routing.REPORT,
    name: "ReportLostStolen",
    component: ReportLostStolen,
    meta: {
      title: "Report Card Lost or Stolen",
      sideBar: true,
      requiresAuth: true
    }
  },
  {
    path: routing.PAGES,
    name: "Pages",
    component: Pages,
    meta: { sideBar: true, requiresAuth: true }
  },
  {
    path: routing.PROFILE,
    name: "ProfileEdit",
    component: ProfileEdit,
    meta: {
      title: "Edit profile and preferences",
      sideBar: true,
      requiresAuth: true
    }
  },
  {
    path: routing.BONUSES,
    name: "MyBonuses",
    component: MyBonuses,
    meta: { title: "My Bonuses", sideBar: true, requiresAuth: true }
  },
  {
    path: routing.TRANSACTIONS,
    name: "AllTransactions",
    component: AllTransactions,
    meta: { title: "View all Transactions", sideBar: true, requiresAuth: true }
  },
  {
    path: routing.POSTS,
    name: "Posts",
    component: Posts,
    meta: { sideBar: false, requiresAuth: true }
  },
  {
    path: routing.FORGOTTENPASS,
    name: "ForgottenPass",
    component: ForgottenPass,
    meta: { title: "Forgotten Password", sideBar: false, requiresAuth: false }
  },
  {
    path: routing.SETNEWPASS,
    name: "ChangePass",
    component: SetNewPass,
    meta: { sideBar: false, requiresAuth: false }
  },
  {
    path: routing.CONFIRMREG,
    name: "ConfirmReg",
    component: ConfirmReg,
    meta: { sideBar: false, requiresAuth: false }
  },
  {
    path: routing.FREEZECARD,
    name: "FreezeCard",
    component: FreezeCard,
    meta: { title: "Freeze Card", sideBar: true, requiresAuth: true }
  },
  {
    path: routing.MYVEHICLE,
    name: "MyVehicle",
    component: MyVehicle,
    meta: { title: "My Vehicle", sideBar: true, requiresAuth: true }
  },
  {
    path: routing.PRIVACY,
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: { title: "Privacy Policy", sideBar: true, requiresAuth: true }
  }
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  // If a subdomain was found, send request for getting cms page by next url.
  const hostnameParts = [window.location.hostname];
  console.log(hostnameParts);
  // const hostnameParts = window.location.hostname.split(".");
  // console.log(hostnameParts);
  if (hostnameParts.length == 1) {
    const subdomain = hostnameParts[0];
    const nextPageUrl = to.path;

    const fetchCmsPageCriteria = {
      subdomain: subdomain,
      pageUrl: nextPageUrl
    } as CmsCriteria;

    store.commit("updateIsCmsUsedMutation", true);
    await store.dispatch(cmsActions.FETCH_CMS_BODY_CLASS_NAME, subdomain);
    await store.dispatch(cmsActions.FETCH_CMS_PAGE, fetchCmsPageCriteria);
    await store.dispatch(cmsActions.FETCH_CMS_MENU, subdomain);
  } else {
    store.commit("updateIsCmsUsedMutation", false);
  }

  // This goes through the matched routes from last to first, finding the closest route with a title.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  let pageTitle = nearestWithTitle?.meta.title;

  // If cms is used and a title for cms page was found, set the document (page) title to that value else set to default.
  const isCmsUsed = store.getters.getIsCmsUsed;
  const cmsPageTitle = store.getters.getCmsPageTitle;
  if (isCmsUsed == true && cmsPageTitle != null) {
    pageTitle = cmsPageTitle;
  }
  document.title = pageTitle + " - BONUS ME";

  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch(authActions.CHECK_IF_AUTHORIZED).then(() => {
      if (store.getters.getAuthStatus) {
        const promise = store.dispatch(authActions.POST_IS_ALIVE);
        promise.then(() => {
          store.dispatch(accountActions.GET_MY_ACCOUNT_DETAILS).then(() => {
            next();
          });
        });
        return;
      }

      next(routing.LOGIN);
    });
  } else {
    next();
  }
});

export default router;
